import { render } from "./quote_card.vue?vue&type=template&id=2b452281"
import script from "./quote_card?vue&type=script&lang=js&external"
export * from "./quote_card?vue&type=script&lang=js&external"

import "./quote_card.vue?vue&type=style&index=0&id=2b452281&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__